<div #statisticsContainer class="yearly-graph">
  <svg id="statistics-graph" width="100%" attr.height="{{ svgComponentHeight }}px"></svg>
  <div id="tooltip" class="yearly-graph__tooltip hidden">
    <p><strong id="title"></strong></p>
    <p><span id="value"></span></p>
    <p><span id="median"></span></p>
  </div>
</div>
